import React, { useState } from 'react';

import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { RootState } from '@whelk/store';
import {
  MenuAboutIcon,
  MenuContactIcon,
  MenuLogoutIconWeb,
  MenuPrivacyPolicy,
  MenuTermsOfService,
} from '@whelk/assets/src/web/new-icons';
import useOpenMMX from '@whelk/hooks/src/useOpenMMX';

import './style.scss';
import Dropdown from '../../../Base/Dropdown';
import { privacyPolicyUrl, termsOfServiceUrl } from '@whelk/const';
import { openUrl } from '@whelk/utils';

function AvatarSection({
  onClickLogout,
  onClickContentUs,
}: {
  onClickLogout: () => void;
  onClickContentUs: () => void;
}) {
  const { t } = useTranslation();
  const [popoverOpen, setPopoverOpen] = useState(false);
  const { openMMX } = useOpenMMX();
  const userAvatar = useSelector((state: RootState) => state.user.webAvatar);

  // 点击联系我们
  const onClickContactUsBtn = () => {
    onClickContentUs();
    setPopoverOpen(false);
  };

  // 点击退出登录
  const onClickLogoutBtn = () => {
    onClickLogout();
    setPopoverOpen(false);
  };

  const menuItems = [
    { label: t('about_minimax'), onClick: openMMX, icon: <MenuAboutIcon /> },
    { label: t('title_contact_us'), onClick: onClickContactUsBtn, icon: <MenuContactIcon /> },
    {
      label: t('login_user_agreement'),
      onClick: () => openUrl(termsOfServiceUrl, true, '_blank'),
      icon: <MenuTermsOfService />,
    },
    {
      label: t('login_privacy_policy'),
      onClick: () => openUrl(privacyPolicyUrl, true, '_blank'),
      icon: <MenuPrivacyPolicy />,
    },
    {
      label: t('settings_logout'),
      onClick: onClickLogoutBtn,
      icon: <MenuLogoutIconWeb />,
    },
  ];

  return (
    <div>
      <Dropdown menu={menuItems}>
        <div className='group relative rounded-full'>
          <div className='h-7 w-7 rounded-full '>
            {/* {userAvatar && ( */}
            <img
              src={userAvatar}
              alt='avatar'
              className='h-7 w-7 cursor-pointer rounded-full'
              onError={(e) => {
                if (e && e.target) {
                  (e.target as HTMLImageElement).src = '/assets/img/product-load-error.png';
                }
              }}
              onClick={() => {
                setPopoverOpen(!popoverOpen);
              }}
            />
            {/* )}å */}
          </div>
          <div className='absolute left-0 top-0 z-[10] hidden h-7 w-7 cursor-pointer rounded-full bg-[rgba(0,0,0,0.40)] group-hover:block' />
        </div>
      </Dropdown>
    </div>
  );
}

function WebUserInfo({
  onClickLogin,
  onClickLogout,
  onClickContentUs,
}: {
  onClickLogin: () => void;
  onClickLogout: () => void;
  onClickContentUs: () => void;
}) {
  const { t } = useTranslation();
  const isLogin = useSelector((state: RootState) => state.user.isLogin);
  // initUserLoading

  return (
    <>
      {isLogin ? (
        <>
          <AvatarSection onClickLogout={onClickLogout} onClickContentUs={onClickContentUs} />
        </>
      ) : (
        <div
          className='text-col_text00 border-col_text00 hover:bg-col_text00 hover:text-col_text05 flex h-[32px] cursor-pointer items-center justify-center rounded-full border px-[16px] text-[13px]  font-medium leading-[17px] md:h-[36px] '
          onClick={onClickLogin}
        >
          {t('button_signin')}
        </div>
      )}
    </>
  );
}

export default WebUserInfo;
